import { Article } from '@article/const';
import { Action } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { ARTICLE } from '../article-state';

export const LOAD_ARTICLE = '[Article] Article Load';
export const LOAD_ARTICLE_SUCCESS = '[Article] Article Load Success';
export const LOAD_ARTICLE_FAIL = '[Article] Article Load Fail';
export const ARTICLE_RESET = '[Article] Article Reset';
export const ARTICLE_SAVE_RATING = '[Article] Article Save Rating';

export class ArticleLoad extends StateUtils.EntityLoadAction {
  readonly type = LOAD_ARTICLE;

  constructor(public code: string) {
    super(ARTICLE, code);
  }
}

export class ArticleLoadFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_ARTICLE_FAIL;

  constructor(
    public code: string,
    public payload: any,
  ) {
    super(ARTICLE, code, payload);
  }
}

export class ArticleLoadSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_ARTICLE_SUCCESS;

  constructor(
    public code: string,
    public payload: Article,
  ) {
    super(ARTICLE, code, payload);
  }
}

export class ArticleReset extends StateUtils.EntityLoaderResetAction {
  readonly type = ARTICLE_RESET;

  constructor(public code: string) {
    super(ARTICLE, code);
  }
}

export class ArticleSaveRating implements Action {
  readonly type = ARTICLE_SAVE_RATING;

  constructor(
    public code: string,
    public rate: number,
  ) {}
}

// action types
export type ArticleAction = ArticleLoad | ArticleLoadSuccess | ArticleLoadFail | ArticleReset;
